var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import { CommonActions } from '../../../localization/helpers.js';
import './TextNodeInput';
import '../../button/SimpleButton';
let IsochroneNodeInput = class IsochroneNodeInput extends LitElement {
    constructor() {
        super(...arguments);
        this.keyValuePairs = [];
    }
    updated(changedProperties) {
        if (changedProperties.has('input') && this.input?.value) {
            this.syncKeyValuePairs();
        }
    }
    syncKeyValuePairs() {
        const value = this.input?.value || {};
        this.keyValuePairs = Object.entries(value).map(([key, value]) => ({
            key: parseFloat(key), // Convertir la clé en nombre
            value: value,
        }));
        this.requestUpdate();
    }
    onKeyChange(index, event) {
        const newKey = parseFloat(event.detail.input.value);
        if (!isNaN(newKey)) {
            this.keyValuePairs = this.keyValuePairs.map((pair, i) => i === index ? { ...pair, key: newKey } : pair);
            this.requestUpdate();
            this.onInputChange();
        }
    }
    onValueChange(index, event) {
        const newValue = event.detail.input.value;
        this.keyValuePairs = this.keyValuePairs.map((pair, i) => i === index ? { ...pair, value: newValue } : pair);
        this.requestUpdate();
        this.onInputChange();
    }
    addKeyValuePair() {
        this.keyValuePairs = [...this.keyValuePairs, { key: 0, value: '' }];
        this.requestUpdate();
    }
    removeKeyValuePair(index) {
        this.keyValuePairs = this.keyValuePairs.filter((_, i) => i !== index);
        this.requestUpdate();
    }
    onInputChange() {
        const keyValueObject = this.keyValuePairs.reduce((acc, pair) => {
            if (!isNaN(pair.key)) {
                acc[pair.key.toString()] = pair.value; // Convertir la clé en chaîne
            }
            return acc;
        }, {});
        this.input.value = keyValueObject;
        this.dispatchEvent(new CustomEvent('node-input-change', {
            detail: {
                key: this.key,
                input: this.input,
            },
            bubbles: true,
            composed: true
        }));
    }
    render() {
        return html `
            <div class="key-value-container">
                ${this.keyValuePairs.map((pair, index) => html `
                    <div class="key-value-row">
                        <text-node-input
                            .input=${{ value: pair.key.toString(), placeholder: msg('Key (Number)', { id: 'nodeInput.placeholder.keyNumber', desc: 'Numeric key placeholder for isochrone input' }) }}
                            @node-input-change=${(e) => this.onKeyChange(index, e)}
                        ></text-node-input>
                        <text-node-input
                            .input=${{ value: pair.value, placeholder: msg('Value', { id: 'nodeInput.placeholder.value', desc: 'Value placeholder for list/key-value input' }) }}
                            @node-input-change=${(e) => this.onValueChange(index, e)}
                        ></text-node-input>
                        <simple-button
                            label="${CommonActions.remove()}"
                            variant="danger"
                            size="small"
                            @button-click=${() => this.removeKeyValuePair(index)}
                        ></simple-button>
                    </div>
                `)}
                <simple-button
                    label="${msg('Add Key/Value', { id: 'nodeInput.action.addKeyValue', desc: 'Add key/value pair button' })}"
                    variant="success"
                    size="small"
                    @button-click=${this.addKeyValuePair}
                ></simple-button>
            </div>
        `;
    }
};
IsochroneNodeInput.styles = css `
      .key-value-container {
        display: flex;
        flex-direction: column;
        gap: 9px;
        padding: 12px;
        border: 1px solid #ddd;
        border-radius: 6px;
        background-color: #f9f9f9;
      }

      .key-value-row {
        display: flex;
        align-items: center;
        gap: 9px;
      }

      text-node-input {
        flex: 1;
      }
    `;
__decorate([
    property({ type: String })
], IsochroneNodeInput.prototype, "key", void 0);
__decorate([
    property({ type: Object })
], IsochroneNodeInput.prototype, "input", void 0);
__decorate([
    state()
], IsochroneNodeInput.prototype, "keyValuePairs", void 0);
IsochroneNodeInput = __decorate([
    localized(),
    customElement('isochrone-node-input')
], IsochroneNodeInput);
export { IsochroneNodeInput };
//# sourceMappingURL=IsochroneNodeInput.js.map